var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlansSentMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 220,
    viewBox: "0 0 219 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.01 66.127C182.01 66.127 211.252 73.8512 217.332 48.0804C223.412 22.3095 196.199 2.9433 177.392 6.66835C158.584 10.3934 173.068 57.6822 134.975 70.2581C134.975 70.2581 106.159 94.1817 87.9092 87.5131C69.6595 80.8446 88.2035 28.9882 64.7469 23.1925C41.2902 17.3969 32.6018 20.0055 32.6018 20.0055",
    stroke: "#E6E6E6",
    strokeWidth: 2.03,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.05 10.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.209 51.6815L107.814 38.592L88.0629 135.76L152.457 148.85L172.209 51.6815Z",
    fill: "#C1C1C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.477 45.4415L109.083 32.3521L89.3317 129.52L153.726 142.61L173.477 45.4415Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.17 51.7564L112.434 40.6301L98.1682 110.813L152.904 121.939L167.17 51.7564Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.795 90.8728L116.959 85.0115L114.525 96.9872L143.36 102.848L145.795 90.8728Z",
    fill: "#24285B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.466 217.626V168.977L187.115 164.633L195.804 217.626H138.466Z",
    fill: "#008EFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.423 144.171L141.501 161.162V168.713L184.06 164.907L181.898 144.171C181.898 144.171 187.115 119.465 180.599 103.388C177.695 95.9348 176.408 87.9497 176.823 79.9616C177.148 72.6029 166.582 70.918 164.643 78.0331C163.841 81.0781 163.283 87.1681 163.344 93.3393C163.365 95.9399 162.818 98.5138 161.74 100.881C159.152 106.626 154.808 117.902 157.416 124.226L152.402 148.87L129.423 144.171Z",
    fill: "#BC775C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M124.053 130.935C126.822 130.935 129.067 128.69 129.067 125.921C129.067 123.152 126.822 120.907 124.053 120.907C121.284 120.907 119.039 123.152 119.039 125.921C119.039 128.69 121.284 130.935 124.053 130.935Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M152.443 148.85L156.746 167.343L141.501 168.713V161.162L129.423 144.17L152.443 148.85Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4489 171.373L85.0874 160.725C85.0874 160.725 93.2074 156.665 102.759 152.605C112.31 148.545 116.755 141.998 115.477 136.984C114.198 131.97 104.758 125.921 104.758 125.921C104.758 125.921 123.312 99.1147 124.043 93.7251C124.774 88.3354 120.115 86.3054 114.035 90.0711C107.955 93.8367 96.0799 108.026 96.0799 108.026C96.0799 108.026 75.7799 98.4651 67.9948 105.124C60.2098 111.782 57.6825 133.178 46.5885 151.631L80.4489 171.373Z",
    fill: "#BC775C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4521 149.794L85.3615 168.135L70.0045 219.037L10.9518 217.626L43.4521 149.794Z",
    fill: "#008EFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.447 63.665L123.171 58.2346L119.461 76.8697L146.737 82.3001L150.447 63.665Z",
    fill: "#3D83D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M150.447 63.665L123.171 58.2346L119.461 76.8697L146.737 82.3001L150.447 63.665Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.18 58.2202L134.203 74.0339L150.453 63.6505L123.18 58.2202Z",
    fill: "#3D83D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9257 8.04895L0 0L25.6287 28.6737L36.9257 8.04895Z",
    fill: "#3D83D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7081 13.9258L34.3476 24.4513L29.1711 22.198L33.7081 13.9258Z",
    fill: "#3D83D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M33.7081 13.9258L34.3476 24.4513L29.1711 22.198L33.7081 13.9258Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M0 0L33.7081 13.9258L29.9628 20.7568L0 0Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansSentMessage);
export default __webpack_public_path__ + "static/media/plans-sent-message.e5d86b087f657f25f32d21c66c5bb146.svg";
export { ForwardRef as ReactComponent };